export const BOOKING_SAVE_URL = "booking/save";
export const BOOKING_SAVE_ERROR = "BOOKING_SAVE_ERROR";
export const BOOKING_SAVE_LOADING = "BOOKING_SAVE_LOADING";
export const BOOKING_SAVE_SUCCESS = "BOOKING_SAVE_SUCCESS";

export const BOOKING_PAGE_URL = "booking/page";
export const BOOKING_PAGE_ERROR = "BOOKING_PAGE_ERROR";
export const BOOKING_PAGE_LOADING = "BOOKING_PAGE_LOADING";
export const BOOKING_PAGE_SUCCESS = "BOOKING_PAGE_SUCCESS";

export const BOOKING_LIST_URL = "booking/list";
export const BOOKING_LIST_ERROR = "BOOKING_LIST_ERROR";
export const BOOKING_LIST_LOADING = "BOOKING_LIST_LOADING";
export const BOOKING_LIST_SUCCESS = "BOOKING_LIST_SUCCESS";

export const BOOKING_VIEW_URL = "booking/view";
export const BOOKING_VIEW_ERROR = "BOOKING_VIEW_ERROR";
export const BOOKING_VIEW_LOADING = "BOOKING_VIEW_LOADING";
export const BOOKING_VIEW_SUCCESS = "BOOKING_VIEW_SUCCESS";

export const BOOKING_APPROVE_URL = "booking/approvenew";
export const BOOKING_APPROVE_ERROR = "BOOKING_APPROVE_ERROR";
export const BOOKING_APPROVE_LOADING = "BOOKING_APPROVE_LOADING";
export const BOOKING_APPROVE_SUCCESS = "BOOKING_APPROVE_SUCCESS";

export const BOOKING_REJECT_URL = "booking/reject";
export const BOOKING_REJECT_ERROR = "BOOKING_REJECT_ERROR";
export const BOOKING_REJECT_LOADING = "BOOKING_REJECT_LOADING";
export const BOOKING_REJECT_SUCCESS = "BOOKING_REJECT_SUCCESS";

export const BOOKING_APPROVE_DISNAK_URL = "booking/approvenew";
export const BOOKING_APPROVE_DISNAK_ERROR = "BOOKING_APPROVE_DISNAK_ERROR";
export const BOOKING_APPROVE_DISNAK_LOADING = "BOOKING_APPROVE_DISNAK_LOADING";
export const BOOKING_APPROVE_DISNAK_SUCCESS = "BOOKING_APPROVE_DISNAK_SUCCESS";

export const BOOKING_REJECT_DISNAK_URL = "booking/reject";
export const BOOKING_REJECT_DISNAK_ERROR = "BOOKING_REJECT_DISNAK_ERROR";
export const BOOKING_REJECT_DISNAK_LOADING = "BOOKING_REJECT_DISNAK_LOADING";
export const BOOKING_REJECT_DISNAK_SUCCESS = "BOOKING_REJECT_DISNAK_SUCCESS";

export const BOOKING_PAYMENT_CONFIRMATION_URL = "booking/payment";
export const BOOKING_PAYMENT_CONFIRMATION_ERROR = "BOOKING_PAYMENT_CONFIRMATION_ERROR";
export const BOOKING_PAYMENT_CONFIRMATION_LOADING = "BOOKING_PAYMENT_CONFIRMATION_LOADING";
export const BOOKING_PAYMENT_CONFIRMATION_SUCCESS = "BOOKING_PAYMENT_CONFIRMATION_SUCCESS";

export const BOOKING_PAYMENT_VALIDATION_URL = "booking/payment_validation";
export const BOOKING_PAYMENT_VALIDATION_ERROR = "BOOKING_PAYMENT_VALIDATION_ERROR";
export const BOOKING_PAYMENT_VALIDATION_LOADING = "BOOKING_PAYMENT_VALIDATION_LOADING";
export const BOOKING_PAYMENT_VALIDATION_SUCCESS = "BOOKING_PAYMENT_VALIDATION_SUCCESS";

export const BOOKING_RO_URL = "booking/ro";
export const BOOKING_RO_ERROR = "BOOKING_RO_ERROR";
export const BOOKING_RO_LOADING = "BOOKING_RO_LOADING";
export const BOOKING_RO_SUCCESS = "BOOKING_RO_SUCCESS";

export const BOOKING_SI_URL = "booking/si";
export const BOOKING_SI_ERROR = "BOOKING_SI_ERROR";
export const BOOKING_SI_LOADING = "BOOKING_SI_LOADING";
export const BOOKING_SI_SUCCESS = "BOOKING_SI_SUCCESS";

export const BOOKING_GENERATE_BL_URL = "booking/generate_bl";
export const BOOKING_GENERATE_BL_ERROR = "BOOKING_GENERATE_BL_ERROR";
export const BOOKING_GENERATE_BL_LOADING = "BOOKING_GENERATE_BL_LOADING";
export const BOOKING_GENERATE_BL_SUCCESS = "BOOKING_GENERATE_BL_SUCCESS";

export const BOOKING_BL_URL = "booking/bl";
export const BOOKING_BL_ERROR = "BOOKING_BL_ERROR";
export const BOOKING_BL_LOADING = "BOOKING_BL_LOADING";
export const BOOKING_BL_SUCCESS = "BOOKING_BL_SUCCESS";

export const BOOKING_GOODS_TAKER_URL = "booking/goods_taker";
export const BOOKING_GOODS_TAKER_ERROR = "BOOKING_GOODS_TAKER_ERROR";
export const BOOKING_GOODS_TAKER_LOADING = "BOOKING_GOODS_TAKER_LOADING";
export const BOOKING_GOODS_TAKER_SUCCESS = "BOOKING_GOODS_TAKER_SUCCESS";

export const BOOKING_STATUS_URL = "booking/status";
export const BOOKING_STATUS_ERROR = "BOOKING_STATUS_ERROR";
export const BOOKING_STATUS_LOADING = "BOOKING_STATUS_LOADING";
export const BOOKING_STATUS_SUCCESS = "BOOKING_STATUS_SUCCESS";

export const STATUS_ORDER_URL = "dashboard/status_order";
export const STATUS_ORDER_ERROR = "STATUS_ORDER_ERROR";
export const STATUS_ORDER_LOADING = "STATUS_ORDER_LOADING";
export const STATUS_ORDER_SUCCESS = "STATUS_ORDER_SUCCESS";

export const CHANGE_STATUS_BOOKING_URL = "booking/update_status_booking";
export const CHANGE_STATUS_BOOKING_LOADING = "CHANGE_STATUS_BOOKING_LOADING";
export const CHANGE_STATUS_BOOKING_SUCCESS = "CHANGE_STATUS_BOOKING_SUCCESS";
export const CHANGE_STATUS_BOOKING_ERROR = "CHANGE_STATUS_BOOKING_ERROR";
